import http from './http.service'
import unit from './api/unit.api.service'
import unitTemplate from './api/unitTemplate.api.service'
import course from './api/course.api.service'
import lesson from './api/lesson.api.service'
import premiumLessons from './api/premiumLessons.api.service'
import standards from './api/standards.api.service'
import dashboard from './api/dashboard.api.service'
import options from './api/options.api.sevise'
import assessment from './api/assessment.api.service'
import system from './api/system.api.service'
import admin from './api/admin.api.service'
import superAdmin from './api/superAdmin.api.service'
import attachment from './api/attachment.api.service'
import testDevelopment from './api/testDevelopment.api.service'
import reports from './api/reports.api.service'
import favorites from './api/favorites.api.service'
import communities from './api/communities.api.service'
import support from './api/support.api.service'
import user from './api/user.api.service'
import ai from './api/ai.api.service'

export default {
  dashboard: dashboard(http),
  lesson: lesson(http),
  premiumLessons: premiumLessons(http),
  unit: unit(http),
  unitTemplate: unitTemplate(http),
  course: course(http),
  standards: standards(http),
  options: options(http),
  assessment: assessment(http),
  system: system(http),
  admin: admin(http),
  attachment: attachment(http),
  testDevelopment: testDevelopment(http),
  reports: reports(http),
  favorites: favorites(http),
  communities: communities(http),
  superAdmin: superAdmin(http),
  support: support(http),
  user: user(http),
  ai: ai(http)
}
